import { render } from "./OurStory.vue?vue&type=template&id=04daf91a&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=04daf91a&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04daf91a"]])

export default __exports__